<form class="filter" #formElement [formGroup]="form">
    <mat-form-field class="margin-right-small">
        <input matInput autocomplete="off" formControlName="CreateDate" [matDatepicker]="pickerFrom" placeholder="Fecha">
        <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="full-width">
        <mat-label>Número</mat-label>
        <input type="number" matInput formControlName="Number">
    </mat-form-field>
    <mat-form-field class="full-width">
        <mat-label>Razón social</mat-label>
        <input typeof="text" matInput formControlName="BusinessName">
    </mat-form-field>
</form>